var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"75de2d07639446afa4ea092f80c9e877fc59df0c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"75de2d07639446afa4ea092f80c9e877fc59df0c"};
      